import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    login: null,
    pass: null,
    load: false
  }),
  mounted () {
    window.localStorage.removeItem('token')
  },
  methods: {
    submit () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.load = true
      axios.post(`${this.getApi}/api/auth/login`, {
        email: this.login,
        password: this.pass
      }).then(res => {
        let token = res.data['access_token']
        this.$store.commit('Auth', token)
        window.localStorage.setItem('token', token)
        this.$nextTick(() => {
          this.$router.push({ path: '/', force: true })
        })
      }).finally(() => {
        this.load = false
      })
    }
  },
  computed: mapGetters(['rules', 'getApi'])
}


// WEBPACK FOOTER //
// ./src/pages/panel/Login/login.js